import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FileText, ArrowUpRight } from "lucide-react";
import { DOCUMENTS } from "@/data/content";
import { fadeUp, stagger, viewportOnce } from "@/lib/motion";

export default function Documents() {
  return (
    <section id="documentos" className="bg-[#F4EFE6] px-4 sm:px-8 lg:px-16 py-20 lg:py-28">
      <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewportOnce}>
        <motion.p variants={fadeUp} className="overline-label text-[#4A0E17]/60">Documentos Oficiais</motion.p>
        <motion.h2 variants={fadeUp} className="font-display mt-4 text-4xl sm:text-5xl font-bold uppercase leading-tight text-[#1C1917]">
          Cartas, Decretos e Estatutos
        </motion.h2>

        <div className="mt-12 border-t border-[#E5DEC9]">
          {DOCUMENTS.map((d, i) => (
            <motion.a
              key={d.title}
              variants={fadeUp}
              data-testid={`document-row-${i}`}
              href={`mailto:chancelaria@dacb.org.br?subject=${encodeURIComponent("Solicitação de documento: " + d.title)}`}
              className="group flex items-center justify-between gap-6 py-7 border-b border-[#E5DEC9] px-2 sm:px-4 hover:bg-[#FBF9F4] transition-colors"
            >
              <div className="flex items-center gap-5">
                <FileText className="h-6 w-6 text-[#C5A059] shrink-0" strokeWidth={1.5} />
                <div>
                  <h3 className="font-display text-lg font-bold text-[#1C1917] group-hover:text-[#4A0E17] transition-colors">{d.title}</h3>
                  <p className="mt-1 text-sm text-[#1C1917]/55">{d.desc}</p>
                </div>
              </div>
              <span className="overline-label hidden sm:flex items-center gap-2 text-[#4A0E17] shrink-0">
                Solicitar <ArrowUpRight className="h-4 w-4 text-[#C5A059]" />
              </span>
            </motion.a>
          ))}
        </div>

        <motion.div variants={fadeUp} className="mt-10">
          <Link
            to="/documentos"
            data-testid="documents-central-cta"
            className="overline-label inline-flex items-center gap-2 bg-[#4A0E17] px-6 py-3 text-[#FBF9F4] transition-colors hover:bg-[#2E070D]"
          >
            Acessar a Central de Documentos <ArrowUpRight className="h-4 w-4 text-[#C5A059]" />
          </Link>
        </motion.div>
      </motion.div>
    </section>
  );
}
